export const WIDGET_ID = 'todolist-widget';
export const CONTENT_CONTAINER_ID = 'TDL-content-container';
export const TODOLIST = 'TODOLIST';
export const WIDGET_QUERY_KEY = `queryKey-${TODOLIST}`;

export const SORT_QUERY_KEY = `sortKey-${TODOLIST}`;
export const USER_NAME_COL = 'OWNERLOGIN';
export const DOC_CUR_DATE_COL = 'DOCCURDATE';

export const COMPLETE_BY = 'TODATEA';
export const STATUS_FIELD = 'STATDES';
export const PRIORITY_FIELD = 'PRIO';
export const DETAILS = 'DETAILS';
export const defaultCols = [DETAILS, STATUS_FIELD, COMPLETE_BY, PRIORITY_FIELD];
export const DOC_NUM = 'TODOREF';
export const DOC_TYPE = 'DOCDES';
export const CUST_NAME = 'CUSTDES';
export const SUPP_NAME = 'SUPDES';
export const E_NAME_COL = 'ENAME';
export const MANDATORY_COLS = [DOC_NUM, DOC_TYPE, CUST_NAME, SUPP_NAME, E_NAME_COL, TODOLIST];
export const REMARKS_SUBFORM_NAME = 'TODOLISTDOCTEXT';
export const INT_DLG_SUBFORM_NAME = 'TODOLISTDOCTEXT2';

export const MIN_ITEMS_FOR_SCROLLBAR = 6;
export const MAX_LOAD = 99;

export const MAIN_COLUMN_WIDTH = 80; // Same value as .mainColumn width at ToDoListConent.module

export const MAX_FIELDS = 4;

export const storageKey = 'todolistWidgetViewColumns';
export const COMPLETED_FIELD = 'COMPLETED';

export const STATUSES_DROPDOWN_MAX_HEIGHT = 336;
export const DROPDOWN_INPUT_HEIGHT = 42;

export const TODOLIST_EXEC = '97548';

// monitoring:
export const monitor = {
    TODOLIST_Delete: 'TODOLIST_Delete',
    TODLIST_Settings: 'TODLIST_Settings',
    TODOLIST_Expand: 'TODOLIST_Expand',
    TODOLIST_DrillDown: 'TODOLIST_DrillDown',
    TODOLIST_Status: 'TODOLIST_Status',
    TODOLIST_Priority: 'TODOLIST_Priority',
    TODOLIST_Text: 'TODOLIST_Text',
    TODOLIST_InternalDialogue: 'TODOLIST_InternalDialogue',
    TODOLIST_FieldsDisaply: 'TODOLIST_FieldsDisaply'
};
